import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';

import { LinkButton } from '@clds/button';
import EmptyState from '@cld/empty-state';

import { useMessage } from '../../i18n/useMessage';
import { modules } from '../side-menu/side-menu.constants';
import { Features, isAllowedForProgrammableMedia } from '../../utils/features';
import imageSrc from './access-denied.svg';

export const RoutesGuard = (props: React.PropsWithChildren<{ features?: Features }>) => {
  const t = useMessage();
  const navigate = useNavigate();
  const onActionButtonClick = () => {
    navigate(modules.dashboard);
  };
  const { isCmsMode, isAllowedForDashboard } = props.features || {};
  const isAllowedToNavigate = !isCmsMode && isAllowedForDashboard;
  const isAccessDenied = props.features && !isAllowedForProgrammableMedia(props.features);

  if (!isAccessDenied) {
    return <>{props.children}</>;
  }

  return (
    <>
      <Helmet title={`${t('page-access-denied-title')} | ${t('default-page-title')}`} />
      <EmptyState
        title={t('page-access-denied-title')}
        subtitle={t('page-access-denied-subtitle')}
        imageSrc={imageSrc}
        imageWidth={175}
        data-test="pm-page-access-denied"
      >
        {isAllowedToNavigate && (
          <LinkButton size={'md'} onClick={onActionButtonClick}>
            {t('page-access-denied-action')}
          </LinkButton>
        )}
      </EmptyState>
    </>
  );
};
